import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class ModalTagManageService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/chatbot-server/api'
  };
  getList(data: { name?: string }) {
    return this.get('/llm/tag/pageQuery', data);
  }
  getList1() {
    return this.get('/llm/tag/listTag');
  }
  addItem(data: { name: string }) {
    return this.post('/llm/tag/create', data);
  }
  // 批量新增
  batchCreate(data: { name: string[] }) {
    return this.post('/llm/tag/batchCreate', data);
  }

  editItem(data: { name: string; id: string }) {
    return this.post(`/llm/tag/update`, data);
  }
  deleteItem(data: { id: string }) {
    return this.post(`/llm/tag/delete`, data);
  }
  /** 修改关联标签 */
  updateRelationTag(data: {
    relatedId: string;
    relationType: string;
    tagId: string[];
  }) {
    return this.post(`/llm/tag/updateRelationTag`, data);
  }
  /** 查询关联标签列表 */
  listByRelationId(data: { relatedId: string }) {
    return this.get(`/llm/tag/listByRelationId`, data);
  }
}
export default new ModalTagManageService();
